var map = {
	"./10set.png": 75888,
	"./1inch.png": 41096,
	"./aave.png": 46268,
	"./abt.png": 79190,
	"./aca.png": 49188,
	"./ace.png": 52512,
	"./ach.png": 45781,
	"./acm.png": 21576,
	"./acn.png": 6851,
	"./acs.png": 37478,
	"./act.png": 30553,
	"./ada.png": 43469,
	"./adx.png": 80412,
	"./ae.png": 19951,
	"./aergo.png": 86547,
	"./aevo.png": 62442,
	"./afc.png": 84757,
	"./agi.png": 408,
	"./agld.png": 26677,
	"./agrs.png": 45624,
	"./aidoge.png": 53628,
	"./ait.png": 46591,
	"./akita.png": 56937,
	"./akt.png": 97361,
	"./alcx.png": 53391,
	"./aleph.png": 27385,
	"./algo.png": 36700,
	"./ali.png": 91069,
	"./alpha.png": 48965,
	"./alt.png": 86952,
	"./amb.png": 87893,
	"./amp.png": 28855,
	"./ampl.png": 70651,
	"./ams.png": 70748,
	"./anc.png": 18125,
	"./anime.png": 39669,
	"./ankr.png": 60707,
	"./ans.png": 40733,
	"./ant.png": 79010,
	"./ape.png": 86725,
	"./api3.png": 73254,
	"./apt.png": 54444,
	"./apx.png": 79296,
	"./aqt.png": 81207,
	"./ar.png": 95968,
	"./arb.png": 3008,
	"./arc.png": 27209,
	"./ardr.png": 17174,
	"./arg.png": 9005,
	"./ark.png": 16017,
	"./arkm.png": 71168,
	"./arpa.png": 43153,
	"./arrr.png": 7072,
	"./arty.png": 98597,
	"./asm.png": 23832,
	"./ast.png": 79625,
	"./aster.svg": 83673,
	"./astr.png": 18911,
	"./ath.png": 90876,
	"./atm.png": 13793,
	"./atom.png": 590,
	"./auction.png": 4342,
	"./audio.png": 87375,
	"./aura.png": 30467,
	"./auto.png": 49524,
	"./avax.png": 24015,
	"./avive.png": 61072,
	"./avt.png": 22362,
	"./axl.png": 88700,
	"./axs.png": 43323,
	"./azy.png": 51515,
	"./b3.png": 65032,
	"./babydoge.png": 87746,
	"./bac.png": 57819,
	"./badger.png": 11992,
	"./bal.png": 53804,
	"./banana.png": 48390,
	"./band.png": 56648,
	"./bar.png": 36194,
	"./bat.png": 7860,
	"./bcd.png": 52638,
	"./bch.png": 67538,
	"./bcn.png": 18500,
	"./beam.png": 29188,
	"./bel.png": 40336,
	"./benji.png": 45497,
	"./bera.png": 97653,
	"./beth.png": 35298,
	"./bfc.png": 43546,
	"./bft.png": 67237,
	"./bico.png": 58188,
	"./bifi.png": 47789,
	"./bigtime.png": 55404,
	"./blast.png": 7323,
	"./bld.png": 79179,
	"./block.png": 87798,
	"./blok.png": 65193,
	"./blt.png": 54107,
	"./blue.png": 13573,
	"./blur.png": 89882,
	"./blz.png": 10133,
	"./bnb.png": 19851,
	"./bnc.png": 98722,
	"./bnt.png": 5485,
	"./bob.png": 40620,
	"./boba.png": 41071,
	"./bome.png": 19518,
	"./bond.png": 21302,
	"./bondly.png": 13579,
	"./bone.png": 75103,
	"./bonk.png": 76433,
	"./bora.png": 61503,
	"./boring.png": 6834,
	"./box.png": 1414,
	"./bpt.png": 12079,
	"./brett.png": 94552,
	"./brise.png": 97468,
	"./brwl.png": 14220,
	"./bsv.png": 35116,
	"./bsw.png": 18005,
	"./btc.png": 10524,
	"./btcs.png": 39709,
	"./btg.png": 19640,
	"./btm.png": 98882,
	"./bto.png": 48720,
	"./bts.png": 44780,
	"./btt.png": 74947,
	"./bxc.png": 31560,
	"./bzz.png": 36519,
	"./c98.png": 30245,
	"./cake.png": 52857,
	"./canto.png": 5568,
	"./capo.png": 92310,
	"./cat.png": 20641,
	"./cats.png": 93054,
	"./cbeth.png": 35441,
	"./cbk.png": 79283,
	"./cbx.png": 17352,
	"./ceek.png": 77077,
	"./cel.png": 27741,
	"./celo.png": 40014,
	"./celr.png": 29691,
	"./cetus.png": 12973,
	"./cfg.png": 88195,
	"./cfx.png": 83348,
	"./chain.png": 90310,
	"./chat.png": 91255,
	"./chess.png": 86309,
	"./cho.png": 98805,
	"./chr.png": 86672,
	"./chz.png": 62040,
	"./cirus.png": 98003,
	"./city.png": 93356,
	"./ckb.png": 45617,
	"./clv.png": 49640,
	"./cmp.png": 77881,
	"./comp.png": 17696,
	"./conv.png": 8179,
	"./core.png": 51540,
	"./coti.png": 60610,
	"./coval.png": 46370,
	"./cow.png": 96336,
	"./cre.png": 31917,
	"./cream.png": 68359,
	"./cro.png": 86503,
	"./crt.png": 51143,
	"./crv.png": 27238,
	"./crvusd.png": 45120,
	"./cs.png": 13523,
	"./cspr.png": 97985,
	"./ctc.png": 89805,
	"./ctsi.png": 20632,
	"./ctxc.png": 16759,
	"./cusd.png": 39012,
	"./cvc.png": 56535,
	"./cvp.png": 49036,
	"./cvx.png": 21540,
	"./cxt.png": 86166,
	"./cyber.png": 4698,
	"./dafi.png": 41599,
	"./dag.png": 80189,
	"./dai.png": 54355,
	"./dao.png": 71909,
	"./dar.png": 11456,
	"./dash.png": 42917,
	"./data.png": 86621,
	"./dbc.png": 98136,
	"./dcb.png": 25978,
	"./dck.png": 67547,
	"./dcr.png": 65002,
	"./ddd.png": 23165,
	"./deep.png": 66731,
	"./degen.png": 62644,
	"./dego.png": 15474,
	"./dent.png": 55046,
	"./dep.png": 2574,
	"./deri.png": 22727,
	"./deso.png": 82934,
	"./deus.png": 58336,
	"./devt.png": 87662,
	"./dexe.png": 73161,
	"./df.png": 74287,
	"./dfi.png": 79150,
	"./dfyn.png": 58962,
	"./dgb.png": 42934,
	"./dia.png": 75971,
	"./dice.png": 76872,
	"./dka.png": 80489,
	"./dlc.png": 97050,
	"./dmail.png": 3520,
	"./dmc.png": 68589,
	"./dmtr.png": 10346,
	"./dnt.png": 85587,
	"./dodo.png": 8077,
	"./dog.png": 34643,
	"./doge.png": 24198,
	"./dome.png": 88032,
	"./don.png": 68130,
	"./dope.png": 7947,
	"./dora.png": 20437,
	"./dot.png": 60360,
	"./drgn.png": 19000,
	"./drift.png": 81288,
	"./drop.png": 40062,
	"./dydx.png": 53252,
	"./edg.png": 2927,
	"./edu.png": 96333,
	"./egg.png": 86138,
	"./egld.png": 44601,
	"./ego.png": 39058,
	"./el.png": 52946,
	"./ela.png": 82561,
	"./elec.png": 10906,
	"./elf.png": 15822,
	"./elon.png": 48065,
	"./els.png": 84387,
	"./elt.png": 34988,
	"./emc.png": 33768,
	"./enj.png": 6696,
	"./ens.png": 81049,
	"./eos.png": 92022,
	"./eosdac.png": 65112,
	"./erg.png": 52457,
	"./ern.png": 66696,
	"./ess.png": 15978,
	"./etc.png": 46363,
	"./eth.png": 43432,
	"./ethf.png": 97692,
	"./ethfi.png": 9959,
	"./ethw.png": 43573,
	"./etn.png": 47262,
	"./eur.png": 98569,
	"./eurt.png": 79337,
	"./ever.png": 22581,
	"./evmos.png": 30449,
	"./evo.png": 4685,
	"./ewt.png": 80465,
	"./fame.png": 55720,
	"./farm.png": 89713,
	"./fdc.png": 21464,
	"./fdusd.png": 51107,
	"./fei.png": 63369,
	"./fet.png": 67260,
	"./fida.png": 59171,
	"./fil.png": 42064,
	"./filda.png": 86541,
	"./fire.png": 22417,
	"./fis.png": 28455,
	"./fitfi.png": 77959,
	"./flash.png": 10771,
	"./flm.png": 45806,
	"./floki.png": 57712,
	"./flow.png": 42393,
	"./flr.png": 11977,
	"./flt.png": 8479,
	"./flux.png": 87756,
	"./flx_coin.svg": 33994,
	"./flx_crcl.svg": 34635,
	"./flx_nvda.svg": 17556,
	"./flx_tsla.svg": 52339,
	"./fly.png": 93914,
	"./for.png": 32088,
	"./forth.png": 92884,
	"./fox.png": 11330,
	"./foxy.png": 67833,
	"./frax.png": 93194,
	"./frm.png": 428,
	"./front.png": 60172,
	"./fsn.png": 28624,
	"./fst.png": 84250,
	"./ftm.png": 50070,
	"./ftt.png": 43095,
	"./fuel.png": 27853,
	"./fun.png": 77126,
	"./fx.png": 66215,
	"./fxs.png": 43180,
	"./fyn.png": 55826,
	"./g.png": 34278,
	"./gaia.png": 62963,
	"./gal.png": 2005,
	"./gala.png": 57304,
	"./galft.png": 90771,
	"./game.png": 69995,
	"./game2.png": 16753,
	"./gari.png": 82242,
	"./gas.png": 96898,
	"./gear.png": 72156,
	"./gft.png": 81996,
	"./ghst.png": 94941,
	"./glm.png": 75695,
	"./glmr.png": 52429,
	"./gm.png": 36497,
	"./gmee.png": 71063,
	"./gmt.png": 62017,
	"./gmx.png": 89629,
	"./gno.png": 4983,
	"./gns.png": 70875,
	"./go.png": 7555,
	"./goal.png": 51828,
	"./gods.png": 11156,
	"./gog.png": 42276,
	"./govi.png": 60792,
	"./gpt.png": 99274,
	"./grail.png": 78886,
	"./grin.png": 59023,
	"./grow.png": 55380,
	"./grt.png": 46160,
	"./gt.png": 50704,
	"./gtai.png": 69250,
	"./gtc.png": 95161,
	"./gun.png": 34403,
	"./gusd.png": 81184,
	"./gyen.png": 53112,
	"./hbar.png": 99630,
	"./heart.png": 44729,
	"./hegic.png": 69913,
	"./her.png": 8312,
	"./hero.png": 91821,
	"./hft.png": 84703,
	"./hifi.png": 70571,
	"./high.png": 27053,
	"./hive.png": 65351,
	"./hnt.png": 98631,
	"./honey.png": 34812,
	"./hot.png": 43484,
	"./hpb.png": 45043,
	"./ht.png": 69585,
	"./hype.svg": 1316,
	"./hyper.png": 11063,
	"./ice.png": 61736,
	"./icp.png": 73925,
	"./icx.png": 65853,
	"./id.png": 76158,
	"./idex.png": 51421,
	"./igu.png": 3884,
	"./ilv.png": 59794,
	"./imx.png": 64471,
	"./inj.png": 94452,
	"./inter.png": 43195,
	"./ion.png": 44967,
	"./iost.png": 49052,
	"./iota.png": 97552,
	"./iotx.png": 26865,
	"./iq.png": 81235,
	"./iris.png": 3416,
	"./irl.png": 20886,
	"./j.png": 36627,
	"./jasmy.png": 45229,
	"./joe.png": 30779,
	"./jpg.png": 49420,
	"./jst.png": 26118,
	"./jto.png": 68296,
	"./jup.png": 18724,
	"./juv.png": 51986,
	"./kaia.png": 50463,
	"./kaito.png": 79711,
	"./kan.png": 4019,
	"./kas.png": 5174,
	"./kava.png": 66906,
	"./kcal.png": 96092,
	"./kcs.png": 16792,
	"./kda.png": 91351,
	"./key.png": 57624,
	"./kin.png": 1211,
	"./kine.png": 42878,
	"./kishu.png": 14675,
	"./klay.png": 31390,
	"./klv.png": 4896,
	"./kmd.png": 10021,
	"./knc.png": 23783,
	"./kp3r.png": 37567,
	"./ksm.png": 93510,
	"./ktn.png": 32416,
	"./kub.png": 35211,
	"./lamb.png": 98845,
	"./land.png": 89754,
	"./lat.png": 85086,
	"./layer.png": 17742,
	"./lba.png": 62258,
	"./lbr.png": 59833,
	"./lcx.png": 87560,
	"./ldo.png": 98470,
	"./leash.png": 48486,
	"./leo.png": 79777,
	"./lien.png": 71089,
	"./lina.png": 26063,
	"./ling.png": 80121,
	"./link.png": 78885,
	"./lit.png": 16742,
	"./lith.png": 60076,
	"./lky.png": 20105,
	"./lon.png": 70634,
	"./looks.png": 32545,
	"./loom.png": 81102,
	"./lpt.png": 18577,
	"./lqty.png": 58669,
	"./lrc.png": 44592,
	"./lsk.png": 18403,
	"./ltc.png": 826,
	"./lto.png": 44630,
	"./luna.png": 93683,
	"./luna2.png": 14793,
	"./lunc.png": 19201,
	"./lym.png": 46903,
	"./magic.png": 20000,
	"./maha.png": 44558,
	"./man.png": 54577,
	"./mana.png": 25804,
	"./manta.png": 75804,
	"./mao.png": 56712,
	"./mars.png": 46930,
	"./mask.png": 24493,
	"./math.png": 18091,
	"./matic.png": 13155,
	"./mav.png": 65689,
	"./max.png": 19319,
	"./mbl.png": 17058,
	"./mbox.png": 58085,
	"./mdao.png": 74914,
	"./mdt.png": 83340,
	"./me.png": 10939,
	"./med.png": 49287,
	"./meme.png": 41657,
	"./mengo.png": 24659,
	"./merl.png": 29305,
	"./metis.png": 74271,
	"./mew.png": 47996,
	"./milo.png": 96180,
	"./mina.png": 29892,
	"./mint.png": 53785,
	"./mir.png": 65781,
	"./mith.png": 58531,
	"./mkr.png": 74403,
	"./mlk.png": 51731,
	"./mln.png": 9390,
	"./mnt.png": 70366,
	"./mnw.png": 56117,
	"./moca.png": 96277,
	"./mojo.png": 92424,
	"./mon.png": 46651,
	"./mot.png": 93089,
	"./move.png": 95366,
	"./movez.png": 51822,
	"./movr.png": 65225,
	"./mpl.png": 82952,
	"./msn.png": 38647,
	"./mta.png": 40305,
	"./mtl.png": 93348,
	"./mtn.png": 28822,
	"./muse.png": 87863,
	"./mvl.png": 10670,
	"./mxc.png": 28983,
	"./mxm.png": 75353,
	"./myria.png": 26203,
	"./nano.png": 6287,
	"./nct.png": 93746,
	"./near.png": 70703,
	"./nebl.png": 69604,
	"./neo.png": 59447,
	"./nest.png": 29335,
	"./net.png": 54180,
	"./nexo.png": 7837,
	"./nft.png": 129,
	"./nftb.png": 58775,
	"./nkn.png": 32400,
	"./nmr.png": 28698,
	"./nos.png": 58617,
	"./not.png": 53638,
	"./nrv.png": 67255,
	"./ntrn.png": 64019,
	"./nuls.png": 41005,
	"./nyan.png": 59783,
	"./nym.png": 13585,
	"./oas.png": 88426,
	"./oax.png": 20409,
	"./ocean.png": 78339,
	"./ocn.png": 21353,
	"./ogn.png": 23621,
	"./okb.png": 27965,
	"./okt.png": 40443,
	"./olt.png": 23798,
	"./om.png": 58649,
	"./omg.png": 63122,
	"./omi.png": 32236,
	"./omn.png": 62403,
	"./omni.png": 43002,
	"./ondo.png": 50542,
	"./one.png": 20597,
	"./ong.png": 71559,
	"./ont.png": 74716,
	"./op.png": 64812,
	"./opul.png": 85407,
	"./orai.png": 57072,
	"./orb.png": 76670,
	"./orbs.png": 36375,
	"./orc.png": 94983,
	"./orca.png": 89294,
	"./ordi.png": 76587,
	"./orn.png": 14866,
	"./osmo.png": 92671,
	"./ost.png": 57507,
	"./ox.png": 34756,
	"./oxt.png": 90266,
	"./pai.png": 96127,
	"./palm.png": 54461,
	"./pax.png": 38214,
	"./paxg.png": 83163,
	"./pay.png": 19759,
	"./pci.png": 22549,
	"./pda.png": 29092,
	"./pendle.png": 90147,
	"./people.png": 40512,
	"./pepe.png": 57733,
	"./perl.png": 42462,
	"./perp.png": 46402,
	"./pha.png": 56616,
	"./pi.png": 63644,
	"./pickle.png": 73979,
	"./pika.png": 91128,
	"./pip.png": 65606,
	"./pivx.png": 24698,
	"./pixel.png": 16761,
	"./plu.png": 15080,
	"./png.png": 10868,
	"./pnk.png": 60408,
	"./pnt.png": 7788,
	"./pokt.png": 32975,
	"./pol.png": 49484,
	"./pols.png": 21325,
	"./polydoge.png": 17955,
	"./polyx.png": 51167,
	"./pond.png": 62152,
	"./pool.png": 96491,
	"./pop.png": 37072,
	"./por.png": 87234,
	"./powr.png": 7565,
	"./ppt.png": 97181,
	"./prcl.png": 74978,
	"./prime.png": 5040,
	"./pro.png": 99368,
	"./prom.png": 69039,
	"./pros.png": 28337,
	"./prq.png": 71302,
	"./psg.png": 74379,
	"./psp.png": 20068,
	"./pstake.png": 81503,
	"./ptc.png": 14054,
	"./puffer.png": 42229,
	"./pundix.png": 42741,
	"./purr.png": 12608,
	"./purse.png": 98480,
	"./pyr.png": 3927,
	"./pyth.png": 78064,
	"./qi.png": 75651,
	"./qkc.png": 72830,
	"./qnt.png": 25234,
	"./qsp.png": 66813,
	"./qtcon.png": 49012,
	"./qtum.png": 72424,
	"./quick.png": 58212,
	"./raca.png": 6986,
	"./rad.png": 37172,
	"./radar.png": 56725,
	"./rai.png": 7841,
	"./rain.png": 14603,
	"./rari.png": 55289,
	"./ray.png": 45105,
	"./rbn.png": 39323,
	"./rdn.png": 60025,
	"./rdnt.png": 11321,
	"./red.png": 82280,
	"./rei.png": 23661,
	"./ren.png": 93682,
	"./render.png": 97825,
	"./rep.png": 76956,
	"./req.png": 94469,
	"./revv.png": 62342,
	"./rif.png": 5262,
	"./rio.png": 24239,
	"./rlc.png": 48708,
	"./rly.png": 57038,
	"./rndr.png": 56267,
	"./ron.png": 13104,
	"./rose.png": 16636,
	"./rpl.png": 39127,
	"./rsr.png": 14008,
	"./rss3.png": 31326,
	"./rune.png": 7029,
	"./runecoin.png": 73114,
	"./rvn.png": 35871,
	"./s.png": 4370,
	"./safe.png": 52742,
	"./sai.png": 65652,
	"./samo.png": 26981,
	"./sand.png": 28375,
	"./sats.png": 71406,
	"./sc.png": 23987,
	"./scr.png": 42665,
	"./scrt.png": 80233,
	"./sd.png": 24028,
	"./sdex.png": 98891,
	"./sei.png": 46144,
	"./sfi.png": 67293,
	"./sfm.png": 88505,
	"./sfp.png": 92108,
	"./shdw.png": 8907,
	"./shell.png": 30711,
	"./shib.png": 47673,
	"./shr.png": 52467,
	"./sidus.png": 60537,
	"./sign.png": 43398,
	"./sis.png": 13702,
	"./skl.png": 10607,
	"./slerf.png": 25051,
	"./sln.png": 55808,
	"./slp.png": 13838,
	"./smart.png": 70886,
	"./snm.png": 40497,
	"./snt.png": 94832,
	"./snx.png": 56636,
	"./sol.png": 80275,
	"./solo.png": 65116,
	"./sonic.png": 71669,
	"./sos.png": 29604,
	"./soul.png": 2228,
	"./sov.png": 55689,
	"./spell.png": 21535,
	"./spurs.png": 82842,
	"./sqr.png": 17591,
	"./srm.png": 98789,
	"./ssv.png": 63005,
	"./sswp.png": 33870,
	"./stc.png": 15421,
	"./steem.png": 34457,
	"./step.png": 45251,
	"./steth.png": 96335,
	"./stg.png": 67257,
	"./stmx.png": 32675,
	"./storj.png": 35869,
	"./storm.png": 47970,
	"./stpt.png": 24000,
	"./strax.png": 99951,
	"./strk.png": 34845,
	"./stx.png": 54206,
	"./stz.png": 73420,
	"./sui.png": 49648,
	"./sun.png": 76143,
	"./super.png": 77672,
	"./susd.png": 70196,
	"./sushi.png": 65947,
	"./swap.png": 23372,
	"./sweat.png": 82857,
	"./swell.png": 458,
	"./swftc.png": 3326,
	"./sxp.png": 55170,
	"./syn.png": 74547,
	"./sys.png": 5878,
	"./t.png": 9229,
	"./tai.png": 70435,
	"./taiko.png": 93373,
	"./taki.png": 81060,
	"./tama.png": 50606,
	"./tao.png": 9365,
	"./tct.png": 21452,
	"./tel.png": 32789,
	"./tet.png": 32346,
	"./tfuel.png": 52957,
	"./thales.png": 15010,
	"./theta.png": 60661,
	"./thg.png": 43194,
	"./tia.png": 31955,
	"./time.png": 52578,
	"./titan.png": 83247,
	"./tko.png": 90519,
	"./tlm.png": 17172,
	"./tnc.png": 86748,
	"./tnsr.png": 95044,
	"./token.png": 21574,
	"./tomi.png": 53404,
	"./ton.png": 99474,
	"./tra.png": 79338,
	"./trac.png": 49435,
	"./trb.png": 93569,
	"./trc.png": 72440,
	"./tribe.png": 62013,
	"./tru.png": 94718,
	"./trump.png": 57613,
	"./trx.png": 93819,
	"./ttc.png": 74946,
	"./tup.png": 81326,
	"./turbo.png": 21369,
	"./tusd.png": 71381,
	"./twt.png": 89168,
	"./uft.png": 96846,
	"./ulti.png": 31303,
	"./uma.png": 73130,
	"./uncx.png": 98437,
	"./unfi.png": 93087,
	"./uni.png": 1267,
	"./unibot.png": 4356,
	"./unn.png": 1308,
	"./uos.png": 18182,
	"./uro.png": 18465,
	"./usd.png": 82469,
	"./usdc.png": 2522,
	"./usdd.png": 76821,
	"./usde.png": 93932,
	"./usdh.svg": 34968,
	"./usdp.png": 89921,
	"./usdt.png": 26213,
	"./ustc.png": 19274,
	"./utk.png": 66803,
	"./uxlink.png": 94810,
	"./vai.png": 27749,
	"./value.png": 27738,
	"./vana.png": 61833,
	"./vela.png": 62951,
	"./velo.png": 73545,
	"./velodrome.png": 57746,
	"./venom.png": 66398,
	"./vet.png": 61900,
	"./vgx.png": 59626,
	"./via.png": 82133,
	"./vib.png": 14782,
	"./virtual.png": 63920,
	"./vite.png": 31751,
	"./vlx.png": 1587,
	"./vntl_anthropic.webp": 45209,
	"./vntl_openai.webp": 73949,
	"./vntl_spacex.webp": 25905,
	"./vra.png": 14352,
	"./vtho.png": 66516,
	"./vvs.png": 47494,
	"./w.png": 95254,
	"./wagmigames.png": 99391,
	"./wal.png": 39877,
	"./wan.png": 11095,
	"./waves.png": 17315,
	"./waxp.png": 83461,
	"./wbtc.png": 51065,
	"./wct.png": 64667,
	"./wemix.png": 539,
	"./wif.png": 61575,
	"./wifi.png": 9702,
	"./wild.png": 41901,
	"./win.png": 68671,
	"./wing.png": 46112,
	"./wld.png": 63198,
	"./wncg.png": 50028,
	"./woo.png": 82524,
	"./wrx.png": 65004,
	"./wsm.png": 96858,
	"./wxt.png": 63602,
	"./xai.png": 35351,
	"./xaut.png": 9207,
	"./xch.png": 61764,
	"./xcn.png": 29202,
	"./xdc.png": 10942,
	"./xec.png": 48961,
	"./xem.png": 31823,
	"./xeta.png": 57397,
	"./xlm.png": 24568,
	"./xmr.png": 77936,
	"./xno.png": 13540,
	"./xpr.png": 34675,
	"./xprt.png": 19519,
	"./xr.png": 43319,
	"./xrd.png": 38083,
	"./xrp.png": 59511,
	"./xtz.png": 4652,
	"./xvg.png": 14644,
	"./xvs.png": 30528,
	"./xym.png": 26907,
	"./xyo.png": 43049,
	"./xyz_aapl.svg": 5274,
	"./xyz_amd.svg": 8010,
	"./xyz_amzn.svg": 25026,
	"./xyz_coin.svg": 50691,
	"./xyz_gold.svg": 94686,
	"./xyz_googl.svg": 57580,
	"./xyz_hood.svg": 53406,
	"./xyz_intc.svg": 45742,
	"./xyz_meta.svg": 43235,
	"./xyz_msft.svg": 35390,
	"./xyz_mu.svg": 24446,
	"./xyz_nvda.svg": 58533,
	"./xyz_orcl.svg": 53338,
	"./xyz_pltr.svg": 20670,
	"./xyz_tsla.svg": 23790,
	"./xyz_xyz100.svg": 34118,
	"./yfi.png": 83303,
	"./yfii.png": 91782,
	"./ygg.png": 19486,
	"./zbcn.png": 13050,
	"./zec.png": 81807,
	"./zen.png": 70698,
	"./zent.png": 99028,
	"./zero.png": 3763,
	"./zeta.png": 30107,
	"./zeus.png": 8054,
	"./zil.png": 19388,
	"./zk.png": 36040,
	"./zkj.png": 93456,
	"./zrc.png": 21846,
	"./zro.png": 19962,
	"./zrx.png": 43653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82063;